const CardInfoComponent = ({ title, subtitle, icon, col }: { title: string, subtitle: string, icon: string, col: number }) => {

    return (
        <div className={`col-xxl-${col} col-md-${col} mb-5`}>
            <div className="card card-raised border-start border-primary border-4">
                <div className="card-body px-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="me-2">
                            <div className="display-5">{subtitle}</div>
                            <div className="card-text">{title}</div>
                        </div>
                        <div className="icon-circle bg-primary text-white"><i className="material-icons">{icon}</i></div>
                    </div>                   
                </div>
            </div>
        </div>
    );

}

export default CardInfoComponent;